<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_1"><span class="bor">PART <span class="big">I</span></span></a></h1><a id="page_1">
</a><h1 class="part-title"><a id="page_1"><strong>THE WORLD OF THE NEW TESTAMENT</strong></a><a id="page_2"></a></h1><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Part01.vue?2dea3ae4